import { Component, OnInit, OnDestroy, ViewChild, Input } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap';
import { EntityrecordApi, EntityApi, NoteApi } from '../../../sdk/services/custom';
import { LoopBackFilter, Note } from '../../../sdk/models';
import { LoopBackAuth } from '../../../sdk/services/core/auth.service';
import { FormBuilder, FormGroup } from "@angular/forms";
import * as _ from "lodash";
import { PushNotificationsService, NotificationsService } from 'angular2-notifications';
import { PlatformApp } from '../../../services/app.service';
@Component({
    selector: 'notes-display-widget',
    templateUrl: './notes-display.component.html',
    providers: [EntityrecordApi, EntityApi, NoteApi],
    styleUrls: ['./notes-display.component.scss']
})

export class NotesDisplayComponent implements OnInit, OnDestroy {
    @Input() entityid: string;
    @Input() entityrecordid: string;
    filter: LoopBackFilter = <LoopBackFilter>{};
    currentuser: any;
    subscriptions: any = [];
    notifyOptions = PlatformApp.getNotificationOptions();
    form: FormGroup;

    note: Note = new Note();
    notes;
    @ViewChild('editModal') public editModal: ModalDirective;


    constructor(private _NotificationsService: NotificationsService, private _NoteApi: NoteApi,
        private _LoopBackAuth: LoopBackAuth) {

    }

    ngOnInit(): void {
        this.currentuser = this._LoopBackAuth.getCurrentUserData();
        this.refreshData();
        // console.log('Entity Id->' + this.entityid);
        // console.log('Record Id->' + this.entityrecordid);
    }


    public refreshData() {
        let filter: LoopBackFilter = {
            "where": {
                "entityrecordId": this.entityrecordid
            },
            "order": 'createdAt DESC'
        };

        filter["data"] = true;
        this.subscriptions.push(this._NoteApi.find(filter)
            .subscribe((results) => {
                if (results) {
                    console.log('new notes' + JSON.stringify(this.notes));
                    this.notes = results;
                }
            }));
    }

    addNote() {
        this.note.entityId = this.entityid;
        this.note.entityrecordId = this.entityrecordid;
        this.note.createdby = this.currentuser.id;
        this.note.appId = this.currentuser.appId;
        console.log('add note');
        this.subscriptions.push(this._NoteApi.patchOrCreate(this.note)
            .subscribe(() => {
                this.note = new Note();
                console.log('added notes')
                this.refreshData();
            }));
    }


    ngOnDestroy() {
        for (var i = 0; i < this.subscriptions.length; i++) this.subscriptions[i].unsubscribe();
    }

    notify(type, title?, content?, options?) {
        if (!options) options = PlatformApp.getNotificationOptions();
        if (!options.id) options.id = type + '-' + title + '_' + content;
        switch (type) {
            case 'success': this._NotificationsService.success(title, content, options); break;
            case 'alert': this._NotificationsService.alert(title, content, options); break;
            case 'error': this._NotificationsService.error(title, content, options); break;
            case 'info': this._NotificationsService.info(title, content, options); break;
            case 'bare': this._NotificationsService.bare(title, content, options); break;
            default: this._NotificationsService.info(title, content, options);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/widgets/notes-display/notes-display.component.ts